export function tryParseInt(s: string | undefined): number | undefined;
export function tryParseInt(s: string | undefined, defaultValue: number): number;
export function tryParseInt(s: string | undefined, defaultValue?: number) {
    return s && /^-?\d+$/.test(s ?? '') ? parseInt(s, 10) : defaultValue;
}
